import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  position: relative;
  display: table;
`;
const Circle = styled.svg `
  fill: var(--icon-color, currentColor);
  display: block;
  width: var(--icon-size, 20px);
  height: var(--icon-size, 20px);
`;
const Line1 = styled.svg `
  stroke: var(--icon-color, currentColor);
  stroke-linecap: round;
  stroke-width: 1.5;
  position: absolute;
  left: 0;
  top: 0;
  width: var(--icon-size, 20px);
  height: var(--icon-size, 20px);
  stroke-dasharray: 9;
  transform-origin: 50% 50%;
  stroke-dashoffset: 4.5;

  @keyframes line1 {
    50%,
    100% {
      transform: rotate(720deg);
    }
    0%,
    55% {
      stroke-dashoffset: 4.5;
    }
    65%,
    80% {
      stroke-dashoffset: 6.5;
    }
    90%,
    100% {
      stroke-dashoffset: 4.5;
    }
  }

  animation: line1 3.5s linear infinite;
`;
const Line2 = styled(Line1) `
  transform: rotate(70deg);
  stroke-dashoffset: 6;

  @keyframes line2 {
    50%,
    80% {
      transform: rotate(90deg);
    }
    0%,
    55% {
      stroke-dashoffset: 6;
    }
    65%,
    80% {
      stroke-dashoffset: 4;
    }
    90%,
    100% {
      transform: rotate(70deg);
      stroke-dashoffset: 6;
    }
  }

  animation: line2 3.5s linear infinite;
`;
const Tick = styled.div `
  position: absolute;
  inset: 0;

  @keyframes tick {
    0%,
    55% {
      transform: rotate(0deg);
    }
    65%,
    80% {
      transform: translate(-4.5%, 7%) rotate(-45deg);
    }
    90%,
    100% {
      transform: rotate(0deg);
    }
  }

  animation: tick 3.5s linear infinite;
`;
export const IconClock = (props) => {
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(Tick, null,
            React.createElement(Line1, { viewBox: "0 0 20 20" },
                React.createElement("path", { d: "M10 10V1" })),
            React.createElement(Line2, { viewBox: "0 0 20 20" },
                React.createElement("path", { d: "M10 10V1" }))),
        React.createElement(Circle, { viewBox: "0 0 20 20" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0142 2.8475C6.28624 2.8475 3.26416 5.86958 3.26416 9.5975C3.26416 13.3254 6.28624 16.3475 10.0142 16.3475C13.7421 16.3475 16.7642 13.3254 16.7642 9.5975C16.7642 5.86958 13.7421 2.8475 10.0142 2.8475ZM1.76416 9.5975C1.76416 5.04115 5.45781 1.3475 10.0142 1.3475C14.5705 1.3475 18.2642 5.04115 18.2642 9.5975C18.2642 14.1539 14.5705 17.8475 10.0142 17.8475C5.45781 17.8475 1.76416 14.1539 1.76416 9.5975Z" }))));
};
//# sourceMappingURL=Clock.js.map